import { IconChevronDown, pluralize } from '@leland-dev/leland-ui-library';
import { AnimatePresence, domAnimation, LazyMotion, m } from 'framer-motion';
import React, { useState } from 'react';

import GenerateCoachClassCards from './GenerateCoachClassCards';
import { type CoachGroupClassesAllEventsFragment } from './__generated-gql-types__/CoachGroupClasses.generated';

interface CoachGroupClassesProps {
  coachFirstName: string;
  groupClasses: CoachGroupClassesAllEventsFragment[];
}

const CoachGroupClasses: React.FC<CoachGroupClassesProps> = ({
  coachFirstName,
  groupClasses,
}) => {
  const [collapsed, setCollapsed] = useState(true);

  const featuredClasses = groupClasses.slice(0, 3);
  const moreClasses = groupClasses.slice(3);

  return (
    <LazyMotion strict features={domAnimation}>
      <h2 className="mb-8 text-left text-2xl font-medium text-leland-gray-dark">
        {coachFirstName}&rsquo;s free events &amp; group classes
      </h2>
      <div className="grid gap-3">
        <GenerateCoachClassCards classes={featuredClasses} />
        <AnimatePresence initial={false}>
          {collapsed ? null : (
            <m.div
              initial={{ opacity: 0, height: 0 }}
              animate={{ opacity: 1, height: 'auto' }}
              exit={{ opacity: 0, height: 0 }}
              transition={{ duration: 0.2 }}
            >
              <div className="grid gap-3">
                <GenerateCoachClassCards classes={moreClasses} />
              </div>
            </m.div>
          )}
        </AnimatePresence>
      </div>
      {moreClasses.length > 0 ? (
        <button
          className="link link--primary mt-6 flex items-center justify-start space-x-1.5 text-lg font-medium"
          onClick={() => setCollapsed((prevState) => !prevState)}
          id="coach_group_classes:toggle_classes"
        >
          <p>
            {collapsed
              ? `View ${pluralize(moreClasses.length, 'more class')}`
              : 'Collapse classes'}
          </p>
          <IconChevronDown
            className={`size-3 text-leland-primary transition-transform ${
              collapsed ? '' : 'rotate-180'
            }`}
          />
        </button>
      ) : null}
    </LazyMotion>
  );
};

export default CoachGroupClasses;
